export default __webpack_public_path__ + "static/media/secondBg.71b11d88.png";